import * as React from "react";
import { DeviceData } from "../models/DeviceData";
import Modal from "react-bootstrap/Modal";
import { DM_DataSheet } from "../models/DM_DataSheet";
import { LSM_LogicSolverSheet } from "../models/LSM_LogicSolverSheet";
import { SS_SupportSystemSheet } from "../models/SS_SupportSystemSheet";
import { DeviceSheetTypes } from "../models/deviceSheeTypes";
import { DM_DataSheet_Bar } from "../models/DM_DataSheet_Bar";
import { LSM_LogicSolverSheet_Bar } from "../models/LSM_LogicSolverSheet_Bar";
import { SS_SupportSystemSheet_Bar } from "../models/SS_SupportSystemSheet_Bar";


interface Props {
  closeModal: () => void;
  deviceMenuX: number;
  deviceMenuY: number;
  openCustomerDeviceModal: () => void;
  rightClickedDevice?: DM_DataSheet_Bar | null;
  rightClickedLogicDevice?: LSM_LogicSolverSheet_Bar | null;
  rightClickedSupportDevice?: SS_SupportSystemSheet_Bar | null;
  promoteToClientLevel: (deviceSheetTypes: DeviceSheetTypes, sheetId: number) => void;
  customDeviceRight: boolean;
  openConfirmDeletingCustomDataSheetModel: () => void;
}

const style = {
  position: "absolute",
  width: "70px",
  backgroundColor: "#62A669",
  padding: "2px 10px",
  zIndex: 8888888
}


const CustomerDeviceGreenRightClickMenuItems = (props: Props) => {

  return (
    <Modal
      show={true}
      size="sm"
      animation={false}
      onEscapeKeyDown={() => props.closeModal()}
      onHide={() => props.closeModal()}
    >
      {/*Open or Delete Customer Device*/}
      {props.rightClickedDevice != null ?
        <div className="customer_menu" style={{ position: "fixed", display: 'block', top: `${props.deviceMenuY}px`, left: `${props.deviceMenuX}px` }}>
          <span id="customer_open" onClick={() => props.openCustomerDeviceModal()}>Open</span><br></br>
          {props.customDeviceRight
            ? <React.Fragment>
              <span id="customer_delete" onClick={() => props.openConfirmDeletingCustomDataSheetModel()}>Delete</span><br />
              {props.rightClickedDevice.isCustom === true && !props.rightClickedDevice.isClient ?
                <span onClick={() => props.promoteToClientLevel("device", props.rightClickedDevice.dataSheet.dataSheetId)}>
                  Promote to client
                      </span>
                : null
              }
            </React.Fragment>
            : null
          }
        </div>
        :
        null
      }
      {/*Open or Delete Customer Logic Device*/}
      {props.rightClickedLogicDevice != null ?
        <div className="customer_menu" style={{ position: "fixed", display: 'block', top: `${props.deviceMenuY}px`, left: `${props.deviceMenuX}px` }}>
          <span id="customer_open" onClick={() => props.openCustomerDeviceModal()}>Open</span><br></br>
          {props.customDeviceRight
            ? <React.Fragment>
              <span id="customer_delete" onClick={() => props.openConfirmDeletingCustomDataSheetModel()}>Delete</span><br />
              {!props.rightClickedLogicDevice.isClient ?
                <span onClick={() => props.promoteToClientLevel("logicSolver", props.rightClickedLogicDevice.logicSolverSheet.logicSolverSheetId)}>
                  Promote to client
                      </span>
                : null
              }
            </React.Fragment>
            : null
          }
        </div>
        :
        null
      }
      {/*Open or Delete Customer Support Device*/}
      {props.rightClickedSupportDevice != null ?
        <div className="customer_menu" style={{ position: "fixed", display: 'block', top: `${props.deviceMenuY}px`, left: `${props.deviceMenuX}px` }}>
          <span id="customer_open" onClick={() => props.openCustomerDeviceModal()}>Open</span><br></br>
          {props.customDeviceRight
            ? <React.Fragment>
              <span id="customer_delete" onClick={() => props.openConfirmDeletingCustomDataSheetModel()}>Delete</span><br />
              {!props.rightClickedSupportDevice.isClient ?
                <span onClick={() => props.promoteToClientLevel("supportSystem", props.rightClickedSupportDevice.supportSystemSheet.supportSystemSheetId)}>
                  Promote to client
                    </span>
                : null
              }
            </React.Fragment>
            : null
          }
        </div>
        :
        null
      }

    </Modal>
  );
}

export default CustomerDeviceGreenRightClickMenuItems;
